import { gql } from '@apollo/client';

export default gql`
query entityDetailsQuery($type: String!, $id: ID!) {
  entity(type: $type, id: $id) {
    id
    type
    name
    iconName
    iconType
    iconColor
    primaryClass {
      id
      name
      icon
      iconType
      color
    }
  }
}
`;